export enum DateFormat {
  SHORT = 'dd/MM/yyyy',
  SHORT_YEAR = 'dd/MM/yy',
  DAY_MONTH = 'dd/MM',
  MONTH_YEAR = 'MM/yyyy',
  LONG = "dd 'de' MMMM 'de' yyyy",
  LONG_SHORT_MONTH = "dd 'de' MMM 'de' yyyy",
  SQL = 'yyyy-MM-dd'
}

export enum TimeFormat {
  HOUR_MINUTE = 'HH:mm',
  HOUR_MINUTE_SECOND = 'HH:mm:ss'
}
